<template>
    <div class="project-express msg-page">
        <div  class="express-container">
            <div>
                <div class="express-kv"> </div>
                <div class="search-timeline">
                    <van-cell-group title="" :border="false">
                        <!-- <van-field label="手机号码" v-model="formData.mobile" placeholder="请输入您的手机号码" maxlength="11" type="tel" size="large" /> -->
                        <van-cell :value="formData.com" class="" title="快递公司"  is-link  @click="clickCompany">
                            <template>
                                <div :style="{'color':formData.com=='请选择快递公司'?'#c8c9cc':'#2b2b2b','text-align':'left'}">{{formData.com}}</div>
                            </template>
                        </van-cell>
                        <van-popup v-model="showCompany" round  position="bottom">
                            <van-picker show-toolbar :columns="companyArr" @cancel="showCompany = false" @confirm="confirmCompany" />
                        </van-popup>

                        <van-field label="快递单号" v-model="formData.sn" placeholder="请输入您的快递单号" size="large" :required="true" maxlength="100"/>

                    </van-cell-group>
                    <div class="search-tip">此快递查询暂只支持EMS</div>
                </div>
            </div>
            <div class="progress-list" v-if="show">
                <div class="list-cells">
                    <div class="list-cell" v-for="(pitem, pindex) in list" :key="pindex">
                        <div class="cell-point">
                        <van-icon v-if="pindex == 0" size="" name="info" color="#0AA8AF" style="background-color: #0AA8AF;box-shadow:0 0 0 3px rgb(28, 180, 157,0.2);margin-left:-6px"/>
                        <div v-else class="point"></div>
                        </div>
                        <div class="cell-cont" :style="{'color':pitem.time==list[0].time?'#0AA8AF':'#aaa'}">
                        <!-- <div class="cell-title" v-if="pitem.created" >{{splitDate(pitem.created, 'before')}}&nbsp;{{splitDate(pitem.created, 'after')}}</div> -->
                        <div class="cell-title" v-if="pitem.time" >{{pitem.time}}</div>
                        <div v-if="pitem.areaName"  class="progress-text">{{pitem.areaName}}</div>
                        <div class="progress-text" >
                            {{pitem.context}}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="msg-ft">
                <van-button type="info" :disabled="disabled" round block color="#0AA8AF" @click="search">查询</van-button>
            </div>
        </div>


    </div>
</template>

<script>
    import Vue from "vue";
    import { Dialog, Toast } from 'vant'
    import { getExpressInfov1 } from '@/api/api'
    import { checkCellphone } from "@/utils/utils";
    Vue.use(Dialog)
    Vue.use(Toast)

    export default {
        data() {
            return {
                papid: '',
                name: '',
                idsn: '',
                disabled: false,
                formData: {
                    // mobile: '',
                    sn: '',
                    com:'EMS',
                },
                showCompany:false,
                companyArr:['EMS'],
                show: false,
                // express: {
                //     name: '',
                //     sn: '',
                //     get_time: '',
                //     get_content: '',
                //     get_name: ''
                // },
                list:[],//时间线
            }
        },
        created() {},
        methods: {
            async search() {
                // Toast.loading({
                //     duration: 0, // 持续展示 toast
                //     overlay: true,
                //     forbidClick: true
                // });
                this.disabled=true
                if (!this.formData.com || !this.formData.sn) {
                    Toast('请完善信息')
                } else {
                    try {
                        let {
                            data
                        } = await getExpressInfov1(this.formData)
                        if (data.data) {
                            Toast('查询成功')
                            this.show = true
                            this.list=data.data
                        } else {
                            this.show=false
                            console.log("data.message:",data.message)
                            if (data.message.indexOf('400')>=0) {
                                Dialog.alert({
                                    title: '提示',
                                    message: '快递信息为空，请输入正确的快递单号',
                                    confirmButtonColor: '#0AA8AF'
                                }).then(() => {
                                    // on close
                                });
                            }else{
                                Dialog.alert({
                                    title: '提示',
                                    message: '暂未查到与您单号相关的物流信息，请稍后再尝试',
                                    confirmButtonColor: '#0AA8AF'
                                }).then(() => {
                                    // on close
                                });
                            }
                        }
                    } catch (e) {
                        this.show=false
                        Dialog.alert({
                            title: '提示',
                            message: e.response.data.message,
                            confirmButtonColor: '#0AA8AF'
                        }).then(() => {
                            // on close
                        });
                    }
                }
                this.disabled=false
                
            },
            clickCompany(){
                this.showCompany=true
            },
            confirmCompany(value){
                this.formData.com=value
                this.showCompany=false
            },
        }

    }
</script>

<style lang="less" scoped>
    .project-express {
        min-height:100vh;
        // background: #f7f8fa;
        .express-container{
            min-height:100vh;
            display:flex;
            flex-flow:column wrap;
            justify-content: space-between;
            .express-kv {
                height: 200px;
                width: 100%;
                margin-bottom: 15px;
                background:url(../../assets/login_banner.png);
                background-size:cover;
                background-position:center;
                img {
                    height: 100%;
                    width: 100%;
                }
            }
            .search-timeline {
                margin: 16px 3%;
                .van-cell-group__title {
                    background: @theme-color;
                    color: #fff;
                    padding: 10px;
                }
                .van-cell__title{
                    max-width:90px;
                    margin:0;
                }
                /deep/.van-field__label{
                    max-width:90px;
                    margin-right:0!important;
                }
                .search-tip{
                    color:red;
                    text-align:center;
                    margin-top:10px;
                    font-size:14px;
                }
            }
            .msg-ft {
                margin: 30px 20px;
                &>* {
                    margin-bottom: 0;
                }
            }
        }
        .progress-list {
            margin: 23px;
            width: auto;
            border-radius: 10px;
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
            border: 1px solid rgba(255, 255, 255, 0);
            .van-cell-group{
                border-radius: 10px;
                .van-cell{
                    border-radius: 10px;
                }
            }
            .progress-title{
                padding-top:0;
            }
            .list-cells {
                padding:15px 10px 5px 5px;
                .list-cell {
                    .cell-cont {
                        color: #aaa;
                        margin-bottom:10px;
                        .progress-text{
                            font-size:14px;
                        }
                    }
                    &:first-child {
                        .cell-cont {
                            color: @main-green;
                        }
                    }
                }
            }
        }
    }
</style>